export const shiptimeConstants = {
  GETALL_REQUEST: 'SHIPTIME_GETALL_REQUEST',
  GETALL_SUCCESS: 'SHIPTIME_GETALL_SUCCESS',
  GETALL_FAILURE: 'SHIPTIME_GETALL_FAILURE',

  GET_REQUEST: 'SHIPTIME_GET_REQUEST',
  GET_SUCCESS: 'SHIPTIME_GET_SUCCESS',
  GET_FAILURE: 'SHIPTIME_GET_FAILURE',

  ADD_REQUEST: 'SHIPTIME_ADD_REQUEST',
  ADD_SUCCESS: 'SHIPTIME_ADD_SUCCESS',
  ADD_FAILURE: 'SHIPTIME_ADD_FAILURE',

  UPDATE_REQUEST: 'SHIPTIME_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'SHIPTIME_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'SHIPTIME_UPDATE_FAILURE',
}